export const LOGIN_METADATA_COOKIE_NAME = 'hs_login_metadata';
export const LOGIN_EMAIL_COOKIE_NAME = 'hs_login_email_hublet';